__webpack_require__.p = "/kcwellnessmedspa/";